// Importing Swiper core and modules
import Swiper from 'swiper';
import {
  Keyboard,
  Autoplay,
  Navigation,
  Pagination,
  EffectFade,
} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-fade'; // Import CSS for the Fade effect

// Initialize Home Hero Swiper
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.home-hero-slider')) {
    new Swiper('.home-hero-slider', {
      modules: [Keyboard, Autoplay, Navigation, Pagination, EffectFade],
      effect: 'fade',
      crossFade: true,
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      speed: 1200,
      slidesPerView: 1,
      navigation: {
        nextEl: '.next-slide-btn',
        prevEl: '.prev-slide-btn',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 64,
        },
        500: {
          slidesPerView: 1,
          spaceBetween: 75,
        },
        750: {
          slidesPerView: 1,
          spaceBetween: 80,
        },
        1000: {
          slidesPerView: 1,
          spaceBetween: 100,
        },
      },
    });
  }
});
